import { render } from "./Betterio.vue?vue&type=template&id=03b93834&scoped=true"
import script from "./Betterio.vue?vue&type=script&lang=js"
export * from "./Betterio.vue?vue&type=script&lang=js"

import "./Betterio.vue?vue&type=style&index=0&id=03b93834&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b93834"]])

export default __exports__